export const CUSTOMER_SUPPORT_REQUEST = 'CUSTOMER_SUPPORT_REQUEST';
export const CUSTOMER_SUPPORT_SUCCESS = 'CUSTOMER_SUPPORT_SUCCESS';
export const CUSTOMER_SUPPORT_FAILURE = 'CUSTOMER_SUPPORT_FAILURE';
export const customerSupportIssueSuccess = (payload) => ({
    type: CUSTOMER_SUPPORT_SUCCESS,
    payload,
});
export const customerSupportIssueRequest = (payload) => ({
    type: CUSTOMER_SUPPORT_REQUEST,
    payload,
});
export const customerSupportIssueFailure = (payload) => ({
    type: CUSTOMER_SUPPORT_FAILURE,
    payload,
});
